    export default  {
        data() {
            return {
                search: '',
                pagination: {
                    page: 1,
                    limit: 13,
                    total: 0,
                    offset: 0,
                },
            }
        },
        computed: {
            activeOffset() {
                return (this.pagination.page - 1) * this.pagination.limit;
            },
        },
        methods: {
            changePage(page) {
                this.pagination.page = page;
                this.fetchInfo();
            },
            changeValueSearch(value) {
                this.search = value.value;
                this.pagination.page = 1;
                this.fetchInfo();
            },
            fetchInfo() {
                clearTimeout(this.timer)
                this.IS_GLOBAL_LOADING(true);
                this.timer = setTimeout(() => {
                    this.IS_GLOBAL_LOADING(false);
                }, 500)
            },
        }
    }